import React from 'react';

export default function Octagon(): JSX.Element {
  return (
    <svg viewBox="0 0 75 75" width="100px">
      <path d="m5,22 18,-18 28,0 18,18 0,28 -18,18, -28,0 -18,-18z" stroke="#606060" strokeWidth="2" fill="#606060" />
    </svg>
  );
}
